import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import _ from "lodash";
import {
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";
import { CustomTheme } from "../../../../types/customTheme";
import WithLoading from "../../../../utils/WithLoading";
import RGL, { WidthProvider } from "react-grid-layout";
import SingleWidgetBox from "./SingleWidgetBox";
import { GlobalContext } from "../../../../root/App";
import { setLocalStore } from "../../../../utils/store/localStore";
import TextWidgetBox from "./TextWidgetBox";
import EmptyWidgetBoxes from "./EmptyWidgetBoxes";

const ReactGridLayout = WidthProvider(RGL);


export interface DashboardCreateModalProps {
  locationMetricsNode: any;
  stationMetricsNode: any;
  layoutDetails: any;
  isLoading: any;
  clientId: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      marginLeft: "12px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      "& fieldset": {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
  }),
);

const WidgetDetailsModal: React.FunctionComponent<
  DashboardCreateModalProps
> = ({
  locationMetricsNode,
  stationMetricsNode,
  layoutDetails,
  isLoading,
  clientId,
}) => {
  const [layout, setLayout] = useState<any>([]);
  const [configDetails, setConfigDetails] = useState<any>({});
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const getValueByPath = (obj: any, path: string[]) => {
    return path.reduce((acc, key) => acc?.[key], obj);
  };
  const { globalState, setGlobalState } = useContext(GlobalContext);

  useEffect(() => {
    setLayout(layoutDetails);
    setConfigDetails(layoutDetails?.config);
    if (layoutDetails) {
      if (layoutDetails?.config?.isDarkMode === null) {
        setGlobalState({ isDarkMode: false });
        setLocalStore("isDarkMode", false);
      } else if (layoutDetails?.config?.isDarkMode) {
        setGlobalState({ isDarkMode: true });
        setLocalStore("isDarkMode", true);
      } else {
        setGlobalState({ isDarkMode: false });
        setLocalStore("isDarkMode", false);
      }
    }
  }, [layoutDetails]);

  const formattedTime = currentTime.toLocaleString(); // e.g., "6/6/2025, 10:23:45 AM"

  return (
    <>
      <Typography variant="body2" align="left" style={{ marginLeft: "12px" }}>
        {formattedTime}
      </Typography>
      <ReactGridLayout
        isDraggable={false}
        isResizable={false}
        rowHeight={120}
        cols={12}
        layout={layout?.data || []}
        style={{ marginTop: "20px", zIndex: 0 }}
        autoSize
        draggableCancel=".no-drag"
        // useCSSTransforms={true}
      >
        {layout?.data &&
          layout?.data.map((data: any) => {
            if (
              data?.data?.main !== "headBox" &&
              data?.data?.main !== "headNormal" &&
              data?.data?.main !== "spacer"
            ) {
              const value = getValueByPath(
                data?.data?.path[0] === "stationAverageTime"
                  ? { stationAverageTime: stationMetricsNode }
                  : locationMetricsNode,
                data?.data?.path,
              );
              return (
                <div key={data?.data.key}>
                  <SingleWidgetBox
                    widgetData={data?.data}
                    configDetails={configDetails}
                    clientId={clientId}
                  />
                </div>
              );
            } else if (data?.data?.main === "spacer") {
              return (
                <div key={data?.data.key}>
                  <EmptyWidgetBoxes />
                </div>
              );
            } else {
              return (
                <div key={data?.data.key}>
                  <TextWidgetBox widgetData={data} />
                </div>
              );
            }
          })}
      </ReactGridLayout>
    </>
  );
};

export default WithLoading(WidgetDetailsModal);
